var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.classModifiers,on:{"click":_vm.onChange}},[_c('div',{staticClass:"radio__tick"}),_c('div',{staticClass:"radio__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }